import {
  fontFamilyVars,
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';

const CHECK_ICON_SIZE = 70;

const DESCRIPTION_MAX_WIDTH = '700px';

export const wizardIntroClass = style({
  marginBottom: spacingVars['2xl'],
});

export const wizardDescriptionClass = style({
  maxWidth: DESCRIPTION_MAX_WIDTH,
  textAlign: 'center',
});

export const checkBadgeIconClass = style({
  color: semanticTokenVars.feedback.success.default.base,
  fontSize: CHECK_ICON_SIZE,
});

export const counterClass = style({
  display: 'flex',
  gap: spacingVars.xs,
  alignItems: 'flex-end',
  justifyContent: 'center',
  margin: 0,
  fontFamily: fontFamilyVars.body,
  fontSize: fontSizeVars.body.body1,
  lineHeight: lineHeightVars.body.body1,
  fontWeight: fontWeightVars.regular,
  color: semanticTokenVars.content.default.default,
});

export const actionClass = style({
  display: 'flex',
  gap: spacingVars.md,
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: 640,
});
